<template>
    <div>
        <alert-modal
                    :theme="theme"
                    :modalId="alertId"
                    :controller="controller.alertModal"
                    v-if="controller.alertModal != null"
        ></alert-modal>
        <loading-modal
                    :theme="theme"
                    :modalId="loadingId"
                    :controller="controller.loadingModal"
                    v-if="controller.loadingModal != null"
        ></loading-modal>
        <confirm-modal
                    :theme="theme"
                    :modalId="confirmId"
                    :controller="controller.confirmModal"
                    v-if="controller.confirmModal != null"
        ></confirm-modal>
        <otp-modal
                    :theme="theme"
                    :modalId="otpId"
                    :controller="controller.otpModal"
                    v-if="controller.otpModal != null"
        ></otp-modal>
        <terms-modal
                    :theme="theme"
                    :modalId="termsId"
                    :controller="controller.termsModal"
                    v-if="controller.termsModal != null"
        ></terms-modal>
        <confirm-redeem-modal
                    :theme="theme"
                    :modalId="confirmRedeemId"
                    :controller="controller.confirmRedeemModal"
                    v-if="controller.confirmRedeemModal != null"
        ></confirm-redeem-modal>
        <serial-modal
                    :theme="theme"
                    :modalId="serialId"
                    :controller="controller.serialModal"
                    v-if="controller.serialModal != null">
        </serial-modal>
        <shipping-modal
                    :theme="theme"
                    :modalId="shippingId"
                    :controller="controller.shippingModal"
                    v-if="controller.shippingModal != null"></shipping-modal>
        <register-success-modal
                    :theme="theme"
                    :modalId="registerId"
                    :controller="controller.registerSuccessModal"
                    v-if="controller.registerSuccessModal != null"
        ></register-success-modal>
        <confirm-surprise-modal
                    :theme="theme"
                    :modalId="confirmSurpriseId"
                    :controller="controller.confirmSurpriseModal"
                    v-if="controller.confirmSurpriseModal != null"
        ></confirm-surprise-modal>
        <marketing-modal
                    :theme="theme"
                    :modalId="marketingId"
                    :controller="controller.marketingModal"
                    v-if="controller.marketingModal != null"
        ></marketing-modal>
        <marketing-register-modal
                    :theme="theme"
                    :modalId="marketingRegisterId"
                    :controller="controller.marketingRegisterModal"
                    v-if="controller.marketingRegisterModal != null"
        ></marketing-register-modal>
        <age-consent-modal
                    :theme="theme"
                    :modalId="ageConsentId"
                    :controller="controller.ageConsentModal"
                    v-if="controller.ageConsentModal != null"
        ></age-consent-modal>
        <verify-code-modal
                    :theme="theme"
                    :modalId="verifyCodeId"
                    :controller="controller.verifyCodeModal"
                    v-if="controller.verifyCodeModal != null"
        ></verify-code-modal>
        <success-modal
                    :theme="theme"
                    :modalId="successId"
                    :controller="controller.successModal"
                    v-if="controller.successModal != null"
        ></success-modal>
        <cookie-consent-modal
                    :theme="theme"
                    :modalId="cookieConsentId"
                    :controller="controller.cookieConsentModal"
                    v-if="controller.cookieConsentModal != null"
        ></cookie-consent-modal>
        <cookie-modal
                    :theme="theme"
                    :modalId="cookieId"
                    :controller="controller.cookieModal"
                    v-if="controller.cookieModal != null"
        ></cookie-modal>

        <add-to-cart-modal
                    :theme="theme"
                    :modalId="addToCartModalId"
                    :controller="controller.addToCartModal"
                    v-if="controller.addToCartModal != null"
        ></add-to-cart-modal>

        <subcampaign-modal
                    :theme="theme"
                    :modalId="subcampaignId"
                    :controller="controller.subcampaignModal"
                    v-if="controller.subcampaignModal != null"
        ></subcampaign-modal>

        
    </div>
</template>
<script>
import AlertModal from "./AlertModal.vue";
import LoadingModal from "./LoadingModal.vue";
import ConfirmModal from "./ConfirmModal.vue";
import OtpModal from "./OTPModal.vue";
import TermsModal from "./TermsModal.vue";
import ConfirmRedeemModal from "./Redeem/ConfirmRedeemModal.vue";
import SerialModal from "./Redeem/SerialModal.vue";
import ShippingModal from "./Shipping/ShippingModal.vue";
import RegisterSuccessModal from "@/components/Modal/Component/Register/RegisterSuccessModal.vue";
import ConfirmSurpriseModal from "./Surprise/ConfirmSurpriseModal.vue";
import MarketingModal from "./MarketingModal.vue";
import MarketingRegisterModal from "./Register/MarketingRegisterModal.vue";
import AgeConsentModal from "./AgeConsentModal.vue";
import VerifyCodeModal from "./VerifyCodeModal.vue";
import SuccessModal from "./SuccessModal.vue";

import CookieModal from "./CookieConsent/CookieModal.vue";
import CookieConsentModal from "./CookieConsent/CookieConsentModal.vue";
import AddToCartModal from "./AddToCartModal.vue";
import SubcampaignModal from "./Redeem/SubcampaignModal.vue";
/**
 * @property {ModalController} controller (required) /components/Modal/Controller/ModalController.js
 */
export default {
    name: "ModalMaster",

    components: {
        AlertModal,
        LoadingModal,
        ConfirmModal,
        OtpModal,
        TermsModal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingModal,
        RegisterSuccessModal,
        ConfirmSurpriseModal,
        MarketingModal,
        MarketingRegisterModal,
        AgeConsentModal,
        VerifyCodeModal,
        SuccessModal,
        CookieModal,
        CookieConsentModal,
        AddToCartModal,
        SubcampaignModal,
    },
    props: {
        controller: Object,
        theme: String
    },
    data: function() {
        return {
            randomNum: Math.floor(Math.random() * 100000) + '',
            alertId: '',
            loadingId: '',
            confirmId: '',
            otpId: '',
            termsId: '',
            confirmRedeemId: '',
            serialId: '',
            shippingId: '',
            registerId: '',
            confirmSurpriseId: '',
            marketingId: '',
            marketingRegisterId: '',
            ageConsentId: '',
            verifyCodeId: '',
            successId: '',
            cookieId: '',
            cookieConsentId: '',
            addToCartModalId: '',
            subcampaignId: '',
        };
    },
    created: function() {
        this.alertId = 'alert-modal-' + this.randomNum;
        this.loadingId = 'loading-modal-' + this.randomNum;
        this.confirmId = 'confirm-modal-' + this.randomNum;
        this.otpId = 'otp-modal-' + this.randomNum;
        this.termsId = 'terms-modal-' + this.randomNum;
        this.confirmRedeemId = 'confirm-redeem-modal-'  + this.randomNum;
        this.serialId = 'serial-modal-' + this.randomNum;
        this.shippingId = 'shipping-modal-' + this.randomNum;
        this.registerId = 'register-success-modal-' + this.randomNum;
        this.confirmSurpriseId = 'confirm-surprise-modal-'  + this.randomNum;
        this.marketingId = 'marketing-modal-' + this.randomNum;
        this.marketingRegisterId = 'marketing-register-modal-' + this.randomNum;
        this.ageConsentId = 'age-consent-modal-' + this.randomNum;
        this.verifyCodeId = 'verify-code-modal-' + this.randomNum;
        this.successId = 'success-modal-' + this.randomNum;
        // cookie
        this.cookieConsentId = 'cookie-consent-modal-' + this.randomNum;
        this.cookieId = 'cookie-modal-' + this.randomNum;
        this.addToCartModalId = 'add-to-cart-modal-' + this.randomNum;
        this.subcampaignId = 'subcampaign-modal-' + this.randomNum;
        
    }
}
</script>
